jQuery(function($){
	$("#btnGEN").click(function() { 
		domtoimage.toPng(document.querySelector('#choralorg-wrapper')).then(function (dataUrl) {
			var img = new Image();
			img.src = dataUrl;

			document.getElementById('output').innerHTML = '';
			document.getElementById('output').appendChild(img);
		}).catch(function (error) {
			console.error('oops, something went wrong!', error);
		});
	});

});